import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api_client";
import { API_URL } from "../url_config";

const AuthGuard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      localStorage.clear();
      navigate("/");
      return;
    }

    const checkAuth = async () => {
      try {
        await apiClient.get(`${API_URL}/auth/me`);
      } catch (error) {
        localStorage.clear();
        navigate("/");
      }
    };

    checkAuth();
  }, [navigate]);

  return null;
};

export default AuthGuard;
